module.exports = __webpack_public_path__ + "media/images/application/template/tick-d15fe47cef5963662ff3898bbc65a78b.svg";